import React, { Component } from "react";
import moment from "moment";
import Flatpickr from "react-flatpickr";

moment.locale("it");

export default class Noleggio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      from: null,
      to: null,
      accessories: [
        {
          label: "KASKO furto e incendio / giorno",
          price: parseInt(this.props.options.costo_kasco_mese),
          selected: false
        },
        {
          label: "Casco / giorno",
          price: 3,
          selected: false
        }
      ]
    };
  }

  getTotale = (startDate, endDate) => {
    let days = Math.ceil(endDate.diff(startDate, "hours") / 24);
    let total = 0;
    console.log(days);

    let options = this.props.options;

    // FORMULA WEEKEND: 2 days from saturday
    if (days === 2 && startDate.day() === 6) {
      total += parseInt(options.formula_weekend);
    } else {
      switch (days) {
        case 1:
          total += parseInt(options.costo_giorno);
          break;
        case 2:
          total += parseInt(options.costo_due_giorni);
          break;
        case 3:
          total += parseInt(options.costo_tre_giorni);
          break;
        case 4:
          total += parseInt(options.costo_quattro_giorni);
          break;
        case 5:
          total += parseInt(options.costo_cinque_giorni);
          break;
        case 6:
          total += parseInt(options.costo_sei_giorni);
          break;
        case 7:
          total += parseInt(options.costo_settimana);
          break;
        case 15:
          total += parseInt(options.costo_quindici_giorni);
          break;
        case 30:
          total += parseInt(options.costo_mese_giorni);
          break;
      }
    }

    console.log("after days", total);

    this.state.accessories.map((value, i) => {
      if (value.selected) {
        total += value.price * days;
      }
    });

    if (total === 0) {
      return "Richiedi un preventivo personalizzato";
    }

    if (Number.isNaN(total)) {
      return "Impossibile calcolare il totale, lo staff Centro Moto Lodi risponderà alle tue esigenze.";
    }

    return "€ " + total;
  };

  handleAccessories = (value, i) => {
    let accessories = this.state.accessories;
    accessories[i].selected = !accessories[i].selected;
    this.setState({ accessories });
  };

  render() {
    console.log(this.state);
    if (this.state.from && this.state.to) {
      window.NoleggioData = this.state;
      window.NoleggioData.total = this.getTotale(
        this.state.from,
        this.state.to
      );
      window.NoleggioData.title = this.props.options.title;
    }
    return (
      <div style={{ marginBottom: "25px" }}>
        <div style={{ fontWeight: "bold", marginBottom: "25px" }}>
          Seleziona le date per la prenotazione
        </div>
        <div className="field">
          <label style={{ fontSize: "16px" }} class="label">
            Ritiro (giorno e orario)
          </label>
          <div class="control">
            <Flatpickr
              className="input"
              style={{
                height: "38px",
                boxShadow: "inset 0 1px 2px rgba(10, 10, 10, 0.1)"
              }}
              options={{
                time_24hr: true,
                defaultDate: this.state.from
                  ? this.state.from.toDate()
                  : moment().toDate()
              }}
              data-enable-time
              onChange={from => {
                from = from[0];
                this.setState({
                  from: moment(from)
                });
              }}
            />
          </div>
        </div>
        <div className="field">
          <label style={{ fontSize: "16px" }} class="label">
            Consegna (giorno e orario)
          </label>
          <div class="control">
            <Flatpickr
              className="input"
              style={{
                height: "38px",
                boxShadow: "inset 0 1px 2px rgba(10, 10, 10, 0.1)"
              }}
              data-enable-time
              options={{
                time_24hr: true,
                defaultDate: this.state.to
                  ? this.state.to.toDate()
                  : moment().toDate()
              }}
              onChange={to => {
                to = to[0];
                this.setState({
                  to: moment(to)
                });
              }}
            />
          </div>
        </div>

        {this.state.from && this.state.to && (
          <div>
            <div className="box" style={{ marginTop: "40px" }}>
              <p>
                Hai selezionato dal{" "}
                <strong>{this.state.from.format("DD/MM/YYYY")}</strong> al{" "}
                <strong>{this.state.to.format("DD/MM/YYYY")}</strong>
              </p>
              <p>
                Ritiro alle <strong>{this.state.from.format("HH:mm")}</strong>
              </p>
              <p>
                Riconsegna alle <strong>{this.state.to.format("HH:mm")}</strong>
              </p>
            </div>
            <h2 className="title is-5" style={{ marginTop: "40px" }}>
              Accessori
            </h2>
            <div className="box">
              <div className="control is-grouped">
                {this.state.accessories.map((value, i) => (
                  <p className="control" key={i}>
                    <label className="checkbox">
                      <input
                        onChange={() => this.handleAccessories(value, i)}
                        type="checkbox"
                        checked={value.selected}
                      />{" "}
                      {value.label} € {value.price}
                    </label>
                  </p>
                ))}
              </div>
            </div>
            <h2 className="title is-5" style={{ marginTop: "40px" }}>
              Riassunto
            </h2>
            <div className="box">
              <p>Totale: {this.getTotale(this.state.from, this.state.to)}</p>
              <p className="has-text-primary">
                Costo percorrenza FISSO: 0,20 € /km
              </p>
            </div>
          </div>
        )}
      </div>
    );
  }
}
